<script lang="ts" setup>
const props = defineProps<{
  rows?: number | string
  content?: string
  html?: string
}>()

const _rows = ref(props.rows || 1)
const _content = ref(props.content)
const isOpen = ref(false)
const contentRef = ref()
const showExpand = ref(false)

function onExpand() {
  isOpen.value = !isOpen.value
}
onMounted(() => {
  setTimeout(() => {
    const { scrollHeight, offsetHeight } = contentRef.value
    showExpand.value = scrollHeight > offsetHeight
  }, 20)
})
</script>

<template>
  <div class="m-text-ellipsis">
    <div
      v-if="html"
      ref="contentRef"
      :class="{
        hide: !isOpen,
        show: isOpen
      }"
      :style="{
        '-webkit-line-clamp': _rows
      }"
      v-html="html"
    ></div>

    <div
      v-else
      ref="contentRef"
      :class="{
        hide: !isOpen,
        show: isOpen
      }"
      :style="{
        '-webkit-line-clamp': _rows
      }"
    >
      {{ _content }}
    </div>
    <span v-if="showExpand" @click="onExpand">
      {{ isOpen ? '收起' : '展开' }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.m-text-ellipsis {
  .hide {
    white-space: pre-wrap;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .show {
    white-space: pre-wrap;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  span {
    cursor: pointer;
    color: var(--color-primary);
  }
}
</style>
